import { ArrowUpRight, CircleCheckBig } from "lucide-react";
import { Container } from "@/components/ui/container";
import { SectionHeading } from "@/components/ui/section-heading";
import { ReadinessCard } from "@/components/illustrations/readiness-card";

const nextTask = {
  title: "Document how long you keep customer contact information",
  detail: "Example task · Retention · Est. 10 minutes",
};

export function ReadinessPreview() {
  return (
    <section
      aria-labelledby="readiness-preview-heading"
      className="bg-secondary/30 py-16 sm:py-24"
    >
      <Container className="grid gap-12 lg:grid-cols-2 lg:items-center">
        <div className="order-2 lg:order-1">
          <SectionHeading
            align="left"
            titleId="readiness-preview-heading"
            eyebrow="From applicability to action"
            title="See which modules may matter — and what to work on next."
            description="The launch experience is designed to preserve the reason a jurisdiction module was activated, show readiness by framework, and turn the result into prioritized work instead of a wall of legal text."
            className="max-w-xl"
          />

          <ul className="mt-8 space-y-4">
            <li className="flex gap-3">
              <CircleCheckBig className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" />
              <span className="text-sm leading-relaxed text-muted-foreground">
                <strong className="font-semibold text-foreground">Explainable activation</strong> — keep the factual reason and rules version behind each recommended privacy framework.
              </span>
            </li>
            <li className="flex gap-3">
              <CircleCheckBig className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" />
              <span className="text-sm leading-relaxed text-muted-foreground">
                <strong className="font-semibold text-foreground">Framework-aware readiness</strong> — see where the same underlying privacy work creates different obligations or actions.
              </span>
            </li>
            <li className="flex gap-3">
              <CircleCheckBig className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" />
              <span className="text-sm leading-relaxed text-muted-foreground">
                <strong className="font-semibold text-foreground">One clear next step</strong> — move from findings to an operational action with evidence, owner and review context.
              </span>
            </li>
          </ul>

          <div className="mt-8 flex min-w-0 items-center gap-3 rounded-xl border border-border bg-card px-4 py-3 shadow-card">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
              <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
            </span>
            <div className="min-w-0">
              <p className="break-words text-sm font-semibold text-foreground">{nextTask.title}</p>
              <p className="text-xs text-muted-foreground">{nextTask.detail}</p>
            </div>
          </div>
        </div>

        <div className="order-1 mx-auto w-full min-w-0 max-w-md lg:order-2 lg:mx-0 lg:max-w-none">
          <ReadinessCard />
        </div>
      </Container>
    </section>
  );
}
